import React from 'react';
import { Icon } from 'Components/frameworks/icon/Icon';
import moment from 'moment';
import { t } from 'Src/i18n';
import { ICONS } from 'Components/utils/icon/icons';
type Props = {
  person: ProposalAttendeesType;
  upsells: ReadonlyArray<UpsellRental | UpsellActivity>;
};

const displayUpsellDates = (upsell: UpsellRental | UpsellActivity) => {
  const addedUpsell = upsell.pricingInfo.attendees.filter((el) => el.rentedAmount.value !== 0);
  const [[{ startDate, endDate }]] = addedUpsell.map(({ schedules }) =>
    schedules
      .filter(({ isPartiallyRented }) => isPartiallyRented)
      .map((schedule) => ({
        startDate: schedule.startDate,
        endDate: schedule.endDate,
      })),
  );
  const start = moment(startDate).format('L');
  const end = moment(endDate).format('L');

  if (start === end) {
    return start;
  }

  return t('booking.confirmation.dateToBeSelected', {
    activityStartDate: start,
    activityEndDate: end,
  });
};

export const UpsellsBlock = ({ person, upsells }: Props) => {
  return upsells
    .filter((upsell) =>
      upsell.pricingInfo.attendees.find(
        (attendee) => attendee.id === person.id && attendee.rentedAmount.value !== 0,
      ),
    )
    .map<Node>((upsell) => (
      <div
        key={upsell.productInfo.id}
        className="mb-20 space-y-10 rounded-12 bg-white p-20 text-14 shadow-sm"
      >
        <div className="flex w-full justify-between gap-10 text-16 font-bold">
          <p className="w-1/2 font-brand">{upsell.productInfo.label}</p>
          <p>
            {
              upsell.pricingInfo.attendees.find((attendee) => attendee.id === person.id)
                ?.rentedAmountWithoutDiscount?.formattedValue
            }
          </p>
        </div>
        {upsell.productInfo.description && (
          <p className="flex w-3/4 gap-10">
            <Icon className="mt-2 shrink-0" name={ICONS.DURATION} width="1.1rem" />
            {upsell.productInfo.description}
          </p>
        )}
        <p className="flex w-3/4 gap-10">
          <Icon className="mt-2 shrink-0" name={ICONS.DATE} width="1.1rem" />
          {displayUpsellDates(upsell)}
        </p>
      </div>
    ));
};
